export default "__VITE_ASSET__B5QO1mxr__"